import { AppDialog } from 'components'
import { FeedbackTypes, SettingsTypes } from 'globals/constants'
import { useFeedBack, useRolesHelper } from 'hooks'
import { FC, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useSelector } from 'react-redux'
import { FeedbackPayload } from 'sdk'
import { CommonSliceSelector, setIsAppFeedBackDialogOpen } from 'store/slices/common.slice'
import { FeedBackForm } from './FeedBackForm'
import { useAppDispatch } from 'store/app.store'
import { AuthSliceSelector } from 'store/slices'

interface Props {}
export const FeedBackDialog: FC<Props> = () => {
  const { ActivityCenterApiCount } = useSelector(CommonSliceSelector)
  const { Settings, IsAppFeedBackDailogOpen } = useSelector(CommonSliceSelector)
  const { TrialExpiry } = useSelector(AuthSliceSelector)
  const { IsTrialUser } = useRolesHelper()
  const dispatch = useAppDispatch()
  const { control, handleSubmit, getValues } = useForm<FeedbackPayload>({
    defaultValues: {
      Type: FeedbackTypes.Application,
    },
  })
  const { SaveFeedBack, IsSaving } = useFeedBack()

  useEffect(() => {
    if (IsTrialUser()) {
      if (Settings.find((x) => x.UniqueKey === SettingsTypes.APP_FEEDBACK_PROVIDED) != null) {
        const declinedSetting = Settings.find((x) => x.UniqueKey === SettingsTypes.APP_FEEDBACK_DECLINED)
        if (declinedSetting != null) {
          //
        }
        const trialExpiryDate = new Date(+TrialExpiry! * 1000)
        const currentDate = new Date()
        const differenceInMilliseconds = trialExpiryDate.getTime() - currentDate.getTime()
        const differenceInDays = differenceInMilliseconds / (1000 * 60 * 60 * 24)
        if (differenceInDays <= 3 && differenceInDays >= 0) {
          dispatch(setIsAppFeedBackDialogOpen(true))
        }
      }
    }
  }, [ActivityCenterApiCount, Settings])
  return (
    <AppDialog
      title="Rate ParkSitesIO"
      open={IsAppFeedBackDailogOpen}
      onClose={() => dispatch(setIsAppFeedBackDialogOpen(false))}
      appDialogWrapperProps={{
        component: 'form',
        role: 'form',
        onSubmit: handleSubmit(() => SaveFeedBack(getValues())),
      }}
      submitButtonProps={{ isLoading: IsSaving, children: 'Submit' }}
      renderChild={(closeDialog) => <FeedBackForm control={control} />}
    />
  )
}
